import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMCheckbox, IMSwissSelect } from '@insurancemenu/imenu-components-lib';
import { AccessTag } from 'components/common/general/AccessTag';
import { SelectProducerDelegate } from 'store/modules/pick-producer/selectProducerDelegate';
import { ContentSectionStyled, IMFormStyled, ProducerNotFoundLabelStyled } from './styles';
import { SELECT_AGENT_FORM_ID } from '../constants';

interface Props {
  selectProducerDelegate: SelectProducerDelegate;
}

export const SelectAgentForm: React.FC<Props> = observer(({ selectProducerDelegate }) => {
  const { form, availableProducers, showProducerNotFound, isCelticsUser } = selectProducerDelegate;

  return (
    <ContentSectionStyled title="Select Agent" subtitle="Choose an existing agent or add a new one if none match">
      <IMFormStyled id={SELECT_AGENT_FORM_ID} formController={form}>
        <IMSwissSelect
          label="Agent"
          name="producer"
          placeholder="Select agent"
          size="full"
          options={availableProducers.slice().map((producer) => ({
            value: producer.id,
            label: producer.name,
          }))}
        />
        {showProducerNotFound && (
          <IMCheckbox
            label={
              <ProducerNotFoundLabelStyled>
                Can&apos;t find my agent
                {isCelticsUser && <AccessTag accessLimitation="Management Only" />}
              </ProducerNotFoundLabelStyled>
            }
            name="producerNotFound"
            size="full"
          />
        )}
      </IMFormStyled>
    </ContentSectionStyled>
  );
});
